/** Compact checklist shown in the hero at every breakpoint. */
export const heroBenefitRows: string[][] = [
  ['✅ 6 Tomi Premium Illustrati', '✅ 5 Bonus Premium'],
  ['✅ Schemi di Costellazione Illustrati', '✅ 50 Carte di Frasi di Guarigione'],
  ['✅ Modelli di Genogramma Professionali'],
  ['✅ Diario di Integrazione di 90 Giorni'],
]

export const heroMockupUrl =
  'https://cdn.magicpatterns.com/uploads/8rdiN6iPKbBbd2MKtB2FkH/MOCKUP_CONST_ITALIANO.png'

export const audiences: string[] = [
  'Ricercatori Spirituali & Auto-Guaritori',
  'Studenti di Terapia & Psicologia',
  'Persone Bloccate in Schemi Ricorrenti',
  'Chi Soffre in Relazioni Amorose',
  'Persone di Fronte a Blocchi Finanziari Cronici',
  'Coach, Terapeuti & Praticanti Olistici',
  'Facilitatori di Costellazioni Familiari',
  'Chiunque Voglia Comprendere il Proprio Sistema Familiare',
]

export const stats: [string, string][] = [
  ['6', 'Tomi Premium Illustrati'],
  ['300+', 'Pagine di Contenuto'],
  ['50', 'Carte di Frasi di Guarigione'],
  ['11', 'Risorse Complete'],
  ['5', 'Bonus Premium Inclusi'],
]

export const problems: string[] = [
  'Ti senti ansioso, bloccato o vuoto — e non sai perché.',
  'Hai provato la terapia, il journaling, le affermazioni — ma gli schemi ritornano sempre.',
  'Le tue relazioni finiscono sempre nello stesso modo, indipendentemente dalla persona di fronte a te.',
  'Il denaro arriva e scompare come se non fosse mai stato destinato a stare con te.',
  'Provi una colpa profonda quando le cose vanno bene — come se il successo fosse un tradimento.',
  'Porti una tristezza, una rabbia o una paura che non sembra completamente tua.',
  'Ti chiedi segretamente se trasmetterai tutto questo ai tuoi figli.',
]
